import { colors } from '../styles/tokens';

/**
 * Estatus REALES de producto en Proscai que llegan en `NegadoProductoRow.status`:
 * `CATALOGO, FUERA DE CATALOGO, BOTADERO, BAJAS, RESURTIBLE, NO RESURTIBLES,
 * DONACION, OUTLET FLEXI, NUEVA TEMPORADA`. Se agrupan en 3 cubetas de color
 * (spec de Task 7): roja = fuera de circulación/bajas, ámbar = salida física
 * pendiente, gris = el resto (vigente/resurtible/donación/nueva temporada).
 *
 * Reutiliza los tokens `estatus*` ya definidos en `styles/tokens.ts` — esos
 * tokens se nombraron por los 3 placeholders del design handoff (FUERA DE
 * CATÁLOGO/BOTADERO/AGOTADO), pero los valores hex coinciden EXACTO con lo
 * que pide este mapeo real, así que no hace falta declarar tokens nuevos.
 */
const ROJO_STATUSES = new Set(['FUERA DE CATALOGO', 'BAJAS', 'NO RESURTIBLES']);
const AMBAR_STATUSES = new Set(['BOTADERO', 'OUTLET FLEXI']);

/**
 * Lista canónica de los estatus REALES de producto verificados en la BD —
 * fuente ÚNICA para el filtro "Estatus" (multi-select) de la vista Global
 * (PT5): tanto `MultiCombo` en `Filtros.tsx` como cualquier otro consumidor
 * futuro deben importar esta constante en vez de declarar el listado a mano.
 */
export const ESTATUS_OPTIONS: string[] = [
  'CATALOGO',
  'FUERA DE CATALOGO',
  'OUTLET FLEXI',
  'BOTADERO',
  'NO RESURTIBLES',
  'RESURTIBLE',
  'NUEVA TEMPORADA',
  'BAJAS',
  'DONACION',
  'NO APLICA',
];

export interface EstatusBadgeColors {
  bg: string;
  text: string;
}

/**
 * Color de fondo/texto de la insignia de estatus en "Productos más
 * negados", por bucket semántico. Cualquier estatus no listado (incluido
 * uno desconocido/futuro) cae en la cubeta gris por default — nunca revienta.
 */
export function estatusBadgeColors(status: string): EstatusBadgeColors {
  if (ROJO_STATUSES.has(status)) {
    return { bg: colors.estatusFueraCatalogoBg, text: colors.estatusFueraCatalogoText };
  }
  if (AMBAR_STATUSES.has(status)) {
    return { bg: colors.estatusBotaderoBg, text: colors.estatusBotaderoText };
  }
  return { bg: colors.estatusAgotadoBg, text: colors.estatusAgotadoText };
}
